import {ActionTree, GetterTree, Module, MutationTree} from "vuex";
import {RootState} from "@/store/types";
import {
  MaterialDeclaration,
  DeclarationState,
  MaterialDeclarationFilter,
  MaterialDeclarationStatusFilter, MaterialDeclarationStatus,
  selectedSupplierFilter, RawMaterialDeclaration
} from "@/modules/material_declaration/types";
import {
  // getMaterialDeclarations,
  saveMaterialDeclaration,
  saveMaterialDeclarations,
  getMaterialDeclarations, getMaterialDeclarationStatus, saveRawMaterialDeclarations
} from "@/services/material_declaration";
// import {getMaterialDeclarationTransactions} from "@/services/"
export const state: DeclarationState = {
  materialDeclaration: {
    id: 0,
    id_agreement: 0,
    item_code: '',
    item_name: '',
    harmonized_system_code: '',
    product_specific_rule: '',
    originating: false,
    regional_value_content: 0,
  },
  materialDeclarations: [],
  materialDeclarationsStatus: [],
  selectedSupplier: {
    name: '',
    id: ''
  },
  selectedMaterialDeclarationMonth: ''
}

const actions: ActionTree<DeclarationState, RootState> = {
  async SAVE_MATERIAL_DECLARATION(_, materialDeclaration: MaterialDeclaration) {
    return await saveMaterialDeclaration(materialDeclaration);
  },
  async SAVE_MATERIAL_DECLARATIONS(_, materialDeclarations: MaterialDeclaration[]) {
    return await saveMaterialDeclarations(materialDeclarations);
  },
  async SAVE_RAW_MATERIAL_DECLARATIONS(_, materialDeclarations: RawMaterialDeclaration[]) {
    return await saveRawMaterialDeclarations(materialDeclarations);
  },
  async GET_MATERIAL_DECLARATIONS(_, payload: MaterialDeclarationFilter) {
    return await getMaterialDeclarations(payload);
  },
  async GET_MATERIAL_DECLARATIONS_STATUS(_, payload: MaterialDeclarationStatusFilter) {
    return await getMaterialDeclarationStatus(payload);
  }
}

const mutations: MutationTree<DeclarationState> = {
  SET_MATERIAL_DECLARATIONS(state, materialDeclarations: MaterialDeclaration[]) {
    state.materialDeclarations = materialDeclarations;
  },
  SET_MATERIAL_DECLARATION_STATUS(state, materialDeclarationsStatus: MaterialDeclarationStatus[]) {
    state.materialDeclarationsStatus = materialDeclarationsStatus;
  },
  SET_SELECTED_SUPPLIER(state, selectedSupplier: selectedSupplierFilter) {
    state.selectedSupplier = selectedSupplier;
  },
  SET_SELECTED_MATERIAL_DECLARATION_MONTH(state, selectedMaterialDeclarationMonth: string) {
    state.selectedMaterialDeclarationMonth = selectedMaterialDeclarationMonth;
  }
}

const getters: GetterTree<DeclarationState, RootState> = {
  MATERIAL_DECLARATIONS(state) {
    const {materialDeclarations} = state;
    return [...materialDeclarations];
  },
  MATERIAL_DECLARATION_STATUS(state) {
    const {materialDeclarationsStatus} = state;
    return [...materialDeclarationsStatus];
  },
  SELECTED_SUPPLIER(state) {
    const {selectedSupplier} = state;
    return selectedSupplier;
  },
  SELECTED_MATERIAL_DECLARATION_MONTH(state) {
    const {selectedMaterialDeclarationMonth} = state;
    return selectedMaterialDeclarationMonth;
  }
}

export const material_declaration: Module<DeclarationState, RootState> = {
  state,
  actions,
  getters,
  mutations
}
